import AuthNavComponent from "../module/auth/AuthNav";
import CompanyAdditionalInfo from "./CompanyAdditionalInfo";
import { FormattedMessage } from "react-intl";

export default function CompanyProfile() {
  return (
    <>
      <AuthNavComponent></AuthNavComponent>
      <main>
        <div className="lg:container mx-auto lg:max-w-3xl lg:my-8 my-8 px-4 lg:px-0">
          <div className="w-full h-fit mx-auto lg:p-6 px-4 py-4 bg-white border border-gray-border rounded-xl">
            <div>
              <h1 className=" text-xl">
                <FormattedMessage id="Additional Info" />
              </h1>
              <h3 className=" text-md">
                <FormattedMessage
                  id="RECRUITER.REGISTER.ACCOUNT.ADDITIONALINFO.TEXT"
                  defaultMessage="Additional information helps job seekers know about your company details"
                />
              </h3>
              <div className="w-full">
                <CompanyAdditionalInfo></CompanyAdditionalInfo>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
